// Redeem Modal Functionality
class RedeemModal {
  constructor() {
    this.modal = document.getElementById('redeem-modal');
    this.form = document.getElementById('redeem-form');
    this.confirmBtn = document.getElementById('redeem-confirm');
    this.emailInput = document.getElementById('redeem-email');
    this.codeInput = document.getElementById('redeem-code');
    
    if (!this.modal) return;
    
    this.init();
  }
  
  init() {
    // 绑定关闭事件
    const closeButtons = this.modal.querySelectorAll('[data-redeem-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });
    
    // 表单提交
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    
    // 输入框验证
    this.emailInput.addEventListener('blur', () => this.validateEmail());
    this.codeInput.addEventListener('input', () => this.validateCode());
  }
  
  open() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // 清空表单
    this.form.reset();
    this.clearErrors();
  }
  
  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  
  clearErrors() {
    document.querySelectorAll('.redeem-form__error').forEach(el => {
      el.textContent = '';
    });
    document.querySelectorAll('.redeem-form__input').forEach(el => {
      el.classList.remove('error');
    });
  }
  
  validateEmail() {
    const email = this.emailInput.value.trim();
    const errorEl = document.getElementById('email-error');
    
    if (!email) {
      this.emailInput.classList.add('error');
      errorEl.textContent = 'Email is required';
      return false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.emailInput.classList.add('error');
      errorEl.textContent = 'Please enter a valid email';
      return false;
    }
    
    this.emailInput.classList.remove('error');
    errorEl.textContent = '';
    return true;
  }
  
  validateCode() {
    const code = this.codeInput.value.trim();
    const errorEl = document.getElementById('code-error');
    
    if (!code) {
      this.codeInput.classList.add('error');
      errorEl.textContent = 'Redeem code is required';
      return false;
    }
    
    // if (code.length < 6) {
    //   this.codeInput.classList.add('error');
    //   errorEl.textContent = 'Redeem code must be at least 6 characters';
    //   return false;
    // }
    
    this.codeInput.classList.remove('error');
    errorEl.textContent = '';
    return true;
  }
  
  async handleSubmit(e) {
    e.preventDefault();
    
    const isEmailValid = this.validateEmail();
    const isCodeValid = this.validateCode();
    
    if (!isEmailValid || !isCodeValid) {
      return;
    }
    
    // 禁用确认按钮，防止重复提交
    const originalText = this.confirmBtn.textContent;
    this.confirmBtn.textContent = 'Processing...';
    this.confirmBtn.disabled = true;
    
    // 收集表单数据
    const formData = {
      email: this.emailInput.value.trim(),
      code: this.codeInput.value.trim(),
    };

    const apiErrMsg = document.getElementById('api-error');
    try {
      apiErrMsg.textContent = ''
      const result = await window.apiv2Requester.getMemberInfo(formData.email)
      if (result instanceof Error) {
        apiErrMsg.textContent = result.message;
        return;
      }

      const { error, data } = result;
      if (error !== 0) {
        const errorMap = {
          '405': 'This account does not exist. Please verify the information and try again.',
          '400': 'This account does not exist. Please verify the information and try again.'
        };
        const errorMessage = errorMap[error.toString()] || 'Something went wrong. Please check the network connection and try again later.';
        apiErrMsg.textContent = errorMessage;
        return;
      }

      if(!data.apikey || !data.region){
          apiErrMsg.textContent = 'This account does not exist or abnormal.'
          return;
      }
      if(data.denyRecharge){
          apiErrMsg.textContent = 'Your membership duration has reached the maximum limit.'
          return;
      }

      const primeId = '52408859656497'
      const advancedId = '52408859689265'
      const memberLevelMap = new Map([
          [10, { name: 'free', id: primeId }],
          [20, { name: 'advanced', id: advancedId }],
          [25, { name: 'prime', id: primeId }],
          [30, { name: 'pro', id: '' }]
      ]);

      const id = memberLevelMap.get(data.accountLevel)?.id
      if(!id){
          apiErrMsg.textContent = (id === '' ? 'Your account is already under the Pro Plan, covering all Plan features.' : 'This account is not allowed to recharge.')
          return;
      }

      formData.productId = id
      formData.apikey = data.apikey
      formData.region = data.region

      //加入购物车
      await this.addToCart(formData);
      
      // 跳转到结算页
      window.location.href = `/checkout?discount=${formData.code}`;
      
    } catch (error) {
      console.error('Error:', error);
      apiErrMsg.textContent = 'Something went wrong. Please check the network connection and try again later.'
    } finally {
      this.confirmBtn.textContent = originalText;
      this.confirmBtn.disabled = false;
    }
  }
  
  // 将商品加入购物车
  async addToCart(data) {

     // 先清空购物车
    const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
    });

    if (!clearResponse.ok) {
        throw new Error('Failed to clear cart');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: data.productId,
          quantity: 1,
          properties: {
            'eWeLink Account': data.email,
            '_apikey': data.apikey,
            '_region': data.region,
            '_isRedeemCodeOrder': true
          }
        }]
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }
    
    return response.json();
  }
}

// 初始化模态框
document.addEventListener('DOMContentLoaded', () => {
  window.redeemModal = new RedeemModal();
  
  // 监听自定义事件打开模态框
  document.addEventListener('openRedeemModal', () => {
    window.redeemModal.open();
  });
});